import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ScrollContext } from "react-router-scroll-4";

import "./index.scss";
import "./index.css";

// Import custom components
import store from "./store";
import translations from "./constants/translations";
import FbMessenger from "./components/facebookMessenger/facebookMessenger";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import Layout from "./components/app";
// Lazy-loaded components (modular imports)
import PlaceOrder from "./components/pages/placeOrder";
// const HomePage = React.lazy(() => import("./components/layouts/homePage/main"));
import HomePage from "./components/layouts/homePage/main";
// const CollectionNoSidebar = React.lazy(() =>
//   import("./components/collection/collection-no-sidebar")
// );
import CollectionNoSidebar from "./components/collection/collection-no-sidebar";
// const NoSideBar = React.lazy(() => import("./components/products/no-sidebar"));
import NoSideBar from "./components/products/no-sidebar";
import Login from "./components/pages/login";
import Register from "./components/pages/register";
import Cart1688 from "./components/pages/cart1688";
import TrckPageLoader from "./pixel_utilities/usePixel.js";
import OrderSuccessPage from "./components/pages/order-success-page";
const SearchedProduct = React.lazy(
  () => import("./components/products/searchedProduct"),
);
const Product1688 = React.lazy(
  () => import("./components/products/product1688"),
);
// const Layout = React.lazy(() => import("./components/app"));

const Cart = React.lazy(() => import("./components/cart"));

const wishList = React.lazy(() => import("./components/wishlist/wishlist"));
const checkOut = React.lazy(() => import("./components/checkout"));
const orderSuccess = React.lazy(
  () => import("./components/checkout/success-page"),
);
const Payment = React.lazy(
  () => import("./components/pages/dashboard/payment"),
);
const aboutUs = React.lazy(() => import("./components/pages/about-us"));
const PageNotFound = React.lazy(() => import("./components/pages/404"));

// const Login = React.lazy(() => import("./components/pages/login"));

// const Register = React.lazy(() => import("./components/pages/register"));

const Search = React.lazy(() => import("./components/pages/search"));

const ForgetPassword = React.lazy(
  () => import("./components/pages/forget-password"),
);
const Contact = React.lazy(() => import("./components/pages/contact"));

const Faq = React.lazy(() => import("./components/pages/faq"));
const HowToOrder = React.lazy(() => import("./components/pages/howToOrder"));
const Privacy = React.lazy(() => import("./components/pages/privacy"));
const DeleteAccount = React.lazy(() =>
  import("./components/pages/delete-account")
);
const Refund = React.lazy(() => import("./components/pages/refund"));
const TermsAndCondition = React.lazy(
  () => import("./components/pages/termsAndCondition"),
);
const TaxAndShipping = React.lazy(
  () => import("./components/pages/taxAndShipping"),
);
const ShipForMe = React.lazy(() => import("./components/pages/ship-for-me"));
const RequestProduct = React.lazy(
  () => import("./components/pages/request-product"),
);
const BuyForMe = React.lazy(() => import("./components/pages/buy-for-me"));
const TrackOrder = React.lazy(() => import("./components/pages/track-order"));

const Orders = React.lazy(() => import("./components/pages/myOrders"));
const MyRequestsBuyShip = React.lazy(
  () =>
    import("./components/pages/user-profile/buy-and-ship-for-me/my-request"),
);
const MyOrdersBuyShip = React.lazy(
  () => import("./components/pages/user-profile/buy-and-ship-for-me/my-orders"),
);
const MyForwardingParcelsBuyShip = React.lazy(
  () =>
    import("./components/pages/user-profile/buy-and-ship-for-me/my-forwarding-parcels"),
);
const MyDeliveredBuyShip = React.lazy(
  () =>
    import("./components/pages/user-profile/buy-and-ship-for-me/my-delivered"),
);
const MyRequestsShip = React.lazy(
  () => import("./components/pages/user-profile/ship-for-me/my-request"),
);
const ShipForMeInvoice = React.lazy(
  () =>
    import("./components/pages/user-profile/ship-for-me/invoice-by-order.js"),
);
const BuyAndShipForMeInvoice = React.lazy(
  () =>
    import("./components/pages/user-profile/buy-and-ship-for-me/invoice-by-order.js"),
);
const MyForwardingParcelsShip = React.lazy(
  () =>
    import("./components/pages/user-profile/ship-for-me/my-forwarding-parcels"),
);
const MyDeliveredShip = React.lazy(
  () => import("./components/pages/user-profile/ship-for-me/my-delivered"),
);
const UserInformation = React.lazy(
  () => import("./components/pages/user-profile/profile/information"),
);
const UserSecurity = React.lazy(
  () => import("./components/pages/user-profile/profile/security"),
);
// const Cart1688 = React.lazy(() => import("./components/pages/cart1688"));

// const OrderSuccessPage = React.lazy(() =>
//   import("./components/pages/order-success-page")
// );

// const PlaceOrder = React.lazy(() => import("./components/pages/placeOrder"));

const OrderDetails = React.lazy(
  () => import("./components/pages/orderDetails"),
);
const LogisticsDetails = React.lazy(
  () => import("./components/pages/logisticsDetails"),
);
const TrackingDetails = React.lazy(
  () =>
    import("./components/pages/user-profile/buy-and-ship-for-me/trackingDetails"),
);
const TrackingDetailsShipForMe = React.lazy(
  () => import("./components/pages/user-profile/ship-for-me/trackingDetails"),
);
const AllNotices = React.lazy(
  () => import("./components/pages/notices/index.js"),
);
const NoticeSingle = React.lazy(
  () => import("./components/pages/notices/noticesingle/index.js"),
);
class Root extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <>
          <FbMessenger />
          <FloatingWhatsApp
            phoneNumber="+8801881934658"
            accountName="Alg Team"
            avatar="assets/images/whatsapp.png"
          />
          <BrowserRouter basename={"/"}>
            <ScrollContext>
              <React.Suspense
                fallback={
                  <div class="loader-wrapper">
                    <div
                      class="loader"
                      style={{ backgroundColor: "#ff4a4e" }}
                    ></div>
                  </div>
                }
              >
                <TrckPageLoader />
                <Switch>
                  <Layout>
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/`}
                      component={HomePage}
                    />

                    {/*Routes For custom Features*/}
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/cart`}
                      component={Cart}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/notices`}
                      component={AllNotices}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/notices/:noticeId`}
                      component={NoticeSingle}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/wishlist`}
                      component={wishList}
                    />

                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/checkout`}
                      component={checkOut}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/order-success`}
                      component={orderSuccess}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/order-success/:id`}
                      component={Payment}
                    />

                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/sales/orders`}
                      component={aboutUs}
                    />

                    {/*Routes For Single Product*/}
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/product/:id`}
                      component={NoSideBar}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/taobao/:id`}
                      component={SearchedProduct}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/1688/:id`}
                      component={Product1688}
                    />

                    {/*Routes For Extra Pages*/}
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/about-us`}
                      component={aboutUs}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/refund-policy`}
                      component={Refund}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/terms-and-coditions`}
                      component={TermsAndCondition}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/faq`}
                      component={Faq}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/how-to-order`}
                      component={HowToOrder}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/tax-and-Shipping`}
                      component={TaxAndShipping}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/ship-for-me`}
                      component={ShipForMe}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/request-for-product`}
                      component={RequestProduct}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/track-order`}
                      component={TrackOrder}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/buy-for-me`}
                      component={BuyForMe}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/privacy-policy`}
                      component={Privacy}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/delete-account`}
                      component={DeleteAccount}
                    />

                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/login`}
                      component={Login}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/register`}
                      component={Register}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/search`}
                      component={Search}
                    />

                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/forget-password`}
                      component={ForgetPassword}
                    />

                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/contact`}
                      component={Contact}
                    />

                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/collection/:id`}
                      component={CollectionNoSidebar}
                    />

                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/dashboard`}
                      component={Orders}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/dashboard/user/information`}
                      component={UserInformation}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/dashboard/user/security`}
                      component={UserSecurity}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/dashboard/buy-and-ship-for-me/my-request`}
                      component={MyRequestsBuyShip}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/dashboard/buy-and-ship-for-me/my-request/:orderId`}
                      component={TrackingDetails}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/dashboard/ship-for-me/my-request/:orderId`}
                      component={TrackingDetailsShipForMe}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/dashboard/buy-and-ship-for-me/my-orders`}
                      component={MyOrdersBuyShip}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/dashboard/buy-and-ship-for-me/my-forwarding-parcel`}
                      component={MyForwardingParcelsBuyShip}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/dashboard/buy-and-ship-for-me/my-delivered`}
                      component={MyDeliveredBuyShip}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/dashboard/ship-for-me/my-request`}
                      component={MyRequestsShip}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/dashboard/ship-for/invoice/:bookingId`}
                      component={ShipForMeInvoice}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/dashboard/buy-and-ship-for/invoice/:bookingId`}
                      component={BuyAndShipForMeInvoice}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/dashboard/ship-for-me/my-forwarding-parcel`}
                      component={MyForwardingParcelsShip}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/pages/dashboard/ship-for-me/my-delivered`}
                      component={MyDeliveredShip}
                    />

                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/dashboard/pages/orders/:orderId`}
                      component={OrderDetails}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/dashboard/pages/orderslogistics/:orderId`}
                      component={LogisticsDetails}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/dashboard/pages/cart`}
                      component={Cart1688}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/dashboard/pages/order-success`}
                      component={OrderSuccessPage}
                    />
                    <Route
                      exact
                      path={`${process.env.PUBLIC_URL}/dashboard/pages/place-order`}
                      component={PlaceOrder}
                    />
                  </Layout>
                  <Route exact component={PageNotFound} />
                </Switch>
              </React.Suspense>
            </ScrollContext>
          </BrowserRouter>
        </>
      </Provider>
    );
  }
}

ReactDOM.render(<Root />, document.getElementById("root"));
